module.exports = "/_next/static/images/bank-btpn-icon-c7f4caefee83ae7c1706d0134e56b68b.svg";